export enum AppMenuCaretaker {
  services = 'services',
  offers = 'offers',
  chat = 'chat',
  profile = 'profile',
  options = 'options',
}

export enum AppMenuCustomer {
  home = 'home',
  services = 'services',
  search = 'search',
  chat = 'chat',
  options = 'options',
}



// WEBPACK FOOTER //
// ./src/views/components/AppMenu/AppMenu.model.ts